import React, { useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Stack,
    Select,
    Text,
    Flex,
    RadioGroup,
    Radio,
} from '@chakra-ui/react'
import Input from './Input';
import { useState } from 'react';
import { FaUser, FaUserAlt } from "react-icons/fa";
import Button from './Button';
import { ApproveRequest, ApproveSCN, ApproveSRA, ApproveTransfer, CertifyScn, InventoryAcc, UpdateIir } from '../Utils/ApiCalls';
import { SiQuantcast } from 'react-icons/si';
import { ImPriceTag } from 'react-icons/im';
import { BsFillBookmarkCheckFill } from 'react-icons/bs';



export default function PendingIQA({ isOpen, onOpen, onClose, id, qty, state }) {



    const [Payload, setPayload] = useState({
        approvalresponse: false,
        remark: ""
    });

    const [value, setValue] = React.useState('1')

    const [ApprovePayload, setApprovePayload] = useState({
        supervisorremark: "",
        approvalresponse: false
    });


    const [PayloadAcc, setPayloadAcc] = useState({
        price: "",
        inventoryaccountremark: "",
        status: false
    });
    const [PayloadScn, setPayloadScn] = useState({
        qtycertified: "",
        qtyserviceable: "",
        qtyunserviceable: ""
    });

    


    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: "sdfgvhbnm"
    });


    const [Loading, setLoading] = useState(false);
    const [LoadingReject, setLoadingReject] = useState(false);


    const ProceedSCN = async () => {
        if (parseInt(PayloadScn.qtycertified) + parseInt(PayloadScn.qtyserviceable) + parseInt(PayloadScn.qtyunserviceable) === parseInt(qty)) {
            try {
                setLoading(true)
                let result = await CertifyScn(PayloadScn, id);
                console.log("result", result);
                if (result.status == true) {
                    setLoading(false)
                    setSuccessMsg({
                        status: true,
                        msg: "SCN inspected successfully"
                    })

                    setPayloadScn({
                        qtycertified: "",
                        qtyserviceable: "",
                        qtyunserviceable: ""

                    })

                    setTimeout(() => {
                        setSuccessMsg({
                            status: false,
                            msg: ""
                        })
                    }, 3000);

                } else {
                    setLoading(false)
                    setErrorMsg({
                        status: true,
                        msg: result.msg
                    })
                    setTimeout(() => {
                        setErrorMsg({
                            status: false,
                            msg: ""
                        })
                    }, 3000);

                }


            } catch (e) {

                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: e.message
                })
                console.error('Error:', e.message);
            }



        } else {
            setErrorMsg({
                status: true,
                msg: "Quantity returned must be equal to the summation of the input field"
            })

            setTimeout(() => {
                setErrorMsg({
                    status: false,

                })
            }, 7000);

        }


    }

    const RejectSra = async () => {
        try {
            setLoadingReject(true)
            if (state === "ApproveSra") {

            }
            let result = state === "ApproveSra" ? await ApproveSRA(ApprovePayload, id) : state === "ApproveScn" ?
                await ApproveSCN(ApprovePayload, id) : state === "ApproveRequest" ?
                    await ApproveRequest(ApprovePayload, id) : await ApproveTransfer(ApprovePayload, id)
            console.log("result", result);
            if (result.status == true) {
                setLoadingReject(false)
                setSuccessMsg({
                    status: true,
                    msg: "Rejected successfully"
                })

                setApprovePayload({
                    supervisorremark: "",
                    approvalresponse: false
                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                    onClose()
                }, 3000);

            } else {
                setLoadingReject(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })
                setTimeout(() => {
                    setApprovePayload({
                        supervisorremark: "",
                        approvalresponse: false
                    })
                    setErrorMsg({
                        status: false,
                        msg: ""
                    })
                }, 3000);


            }


        } catch (e) {

            setLoadingReject(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }


    }
    const ApproveSra = async () => {
        try {
            setLoading(true)

            let result = state === "ApproveSra" ? await ApproveSRA({
                supervisorremark: ApprovePayload.supervisorremark,
                approvalresponse: true
            }, id) : state === "ApproveScn" ? await ApproveSCN({
                supervisorremark: ApprovePayload.supervisorremark,
                approvalresponse: true
            }, id) : state === "ApproveRequest" ?
                await ApproveRequest({
                    supervisorremark: ApprovePayload.supervisorremark,
                    approvalresponse: true
                }, id) : await ApproveTransfer({
                    supervisorremark: ApprovePayload.supervisorremark,
                    approvalresponse: true
                }, id)
            console.log("result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Approved successfully"
                })

                setApprovePayload({
                    supervisorremark: "",
                    approvalresponse: false
                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })

                    onClose()
                }, 3000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })
                setTimeout(() => {
                    setApprovePayload({
                        supervisorremark: "",
                        approvalresponse: false
                    })
                    setErrorMsg({
                        status: false,
                        msg: ""
                    })
                }, 3000);


            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }

    }

    const RejectIQA = async () => {

        try {
            setLoadingReject(true)
            let result = await UpdateIir({
                approvalresponse: false,
                remark: Payload.remark

            }, id);
            console.log("result", result);
            if (result.status == true) {
                setLoadingReject(false)
                setSuccessMsg({
                    status: true,
                    msg: "SRA Rejected successfully"
                })

                setPayload({
                    remark: ""

                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                }, 3000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }
    const ProceedSra = async () => {

        try {
            setLoading(true)
            let result = await UpdateIir({
                approvalresponse: true,
                remark: Payload.remark

            }, id);
            console.log("result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "SRA Approved successfully"
                })

                setPayload({

                    remark: ""

                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                }, 3000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }
    const ProceedInventoryAcc = async () => {

        try {
            setLoading(true)
            let result = await InventoryAcc({
                price: parseInt(PayloadAcc.price), 
                inventoryaccountremark: PayloadAcc.inventoryaccountremark,
                status: PayloadAcc.status === "true" ? true : false
            }, id);
            console.log("ProceedInventoryAcc result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Inventory Account Updated successfully"
                })

                setPayloadAcc({
                    price: "",
                    inventoryaccountremark: "",
                    status: false

                })


                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                    onClose()
                }, 3000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 5000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            setTimeout(() => {
                setErrorMsg({
                    status: false,
                    msg: e.message
                })
            }, 5000);
            console.error('Error:', e.message);
        }



    }
    const handlePendingQA = (e) => {
        setPayload({ ...Payload, [e.target.id]: e.target.value })
    }

    const handleInventoryAcc = (e) => {
        setPayloadAcc({ ...PayloadAcc, [e.target.id]: e.target.value })
    }

    const handleSn = (e) => {
        setPayloadScn({ ...PayloadScn, [e.target.id]: e.target.value })
    }
    const handleApprovePayload = (e) => {
        setApprovePayload({ ...ApprovePayload, [e.target.id]: e.target.value })
    }

   

    useEffect(() => {

    }, [isOpen]);



    return (



        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{state === "certifySra" ? "Certify SRA" : state === "inventoryAcc" ? "Inventory Account" : state === "certifyScn" ? `Certify SCN ` : "Approve"} </ModalHeader>
                <ModalCloseButton />
                <ModalBody>

                    {
                        state === "certifyScn" && (
                            <div>
                                <Stack spacing={"15px"}>
                                    <Input leftIcon={<SiQuantcast />} iconColor="black" labelBg='#fff' label='Qty Certified' id="qtycertified" type='number' value={PayloadScn.qtycertified} val={PayloadScn.qtycertified != "" ? true : false} onChange={handleSn} />
                                    <Input leftIcon={<SiQuantcast />} iconColor="black" labelBg='#fff' label='Qty Serviceable' id="qtyserviceable" type='number' value={PayloadScn.qtyserviceable} val={PayloadScn.qtyserviceable != "" ? true : false} onChange={handleSn} />
                                    <Input leftIcon={<SiQuantcast />} iconColor="black" labelBg='#fff' label='Qty Unserviceable' id="qtyunserviceable" type='number' value={PayloadScn.qtyunserviceable} val={PayloadScn.qtyunserviceable != "" ? true : false} onChange={handleSn} />

                                </Stack>

                                <Button mt="14px" isLoading={Loading}
                                    disabled={PayloadScn.qtycertified != "" && PayloadScn.qtyserviceable != "" && PayloadScn.qtyunserviceable != "" ? false : true}
                                    onClick={ProceedSCN}>Proceed</Button>
                            </div>
                        )
                    }
                    {
                        state === "certifySra" && (
                            <div>
                                <Stack spacing={"15px"}>
                                    <Input leftIcon={<BsFillBookmarkCheckFill />} iconColor="black" labelBg='#fff' label='Remark' id="remark" type='text' value={Payload.remark} val={Payload.remark != "" ? true : false} onChange={handlePendingQA} />

                                </Stack>

                                <Flex justifyContent={"space-between"}>
                                    <Button w="45%" background='red' mt="14px" isLoading={LoadingReject}
                                        disabled={Payload.remark != "" ? false : true}
                                        onClick={RejectIQA}>Reject</Button>

                                    <Button w="45%" mt="14px" isLoading={Loading}
                                        disabled={Payload.remark != "" ? false : true}
                                        onClick={ProceedSra}>Approve</Button>
                                </Flex>
                            </div>
                        )
                    }

                    {
                        state === "inventoryAcc" && (
                            <div>
                                <Stack spacing={"15px"}>
                                    <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Select Approval' fontWeight={"400"} fontSize={PayloadAcc.status != "" ? "16px" : "12px"} id='status' value={PayloadAcc.status} onChange={handleInventoryAcc} >


                                        <option value={true}>Yes</option>
                                        <option value={false}>No</option>



                                    </Select>

                                    <Input leftIcon={<ImPriceTag />} isDisabled={PayloadAcc.status ===true ? true: false } iconColor="black" labelBg='#fff' label='Price' id="price" type='number' value={PayloadAcc.price} val={PayloadAcc.price != "" ? true : false} onChange={handleInventoryAcc} />
                                    <Input leftIcon={<BsFillBookmarkCheckFill />} iconColor="black" labelBg='#fff' label='Inventory Account Remark' id="inventoryaccountremark" type='text' value={PayloadAcc.inventoryaccountremark} val={PayloadAcc.inventoryaccountremark != "" ? true : false} onChange={handleInventoryAcc} />


                                </Stack>

                                <Button mt="14px" isLoading={Loading}
                                    disabled={PayloadAcc.price != "" && PayloadAcc.inventoryaccountremark != "" && PayloadAcc.status != "" ? false : true}
                                    onClick={ProceedInventoryAcc}>Proceed</Button>
                            </div>
                        )
                    }

                    {
                        (state === "ApproveSra" || state === "ApproveScn" || state === "ApproveRequest" || state === "ApproveTransfer") && (

                            <div>

                                <Stack spacing={"15px"}>
                                    <Input leftIcon={<BsFillBookmarkCheckFill />} iconColor="black" labelBg='#fff' label='Supervisor Remark' id="supervisorremark" type='text' value={ApprovePayload.supervisorremark} val={ApprovePayload.supervisorremark != "" ? true : false} onChange={handleApprovePayload} />


                                </Stack>



                                <Flex justifyContent={"space-between"}>
                                    <Button w='45%' mt="14px" isLoading={LoadingReject}
                                        disabled={ApprovePayload.supervisorremark != "" ? false : true}
                                        onClick={RejectSra} background="red">Reject
                                    </Button>

                                    <Button w='45%' mt="14px" isLoading={Loading}
                                        disabled={ApprovePayload.supervisorremark != "" ? false : true}
                                        onClick={ApproveSra} background="green">Approve
                                    </Button>
                                </Flex>
                            </div>
                        )
                    }



                    {
                        errorMsg.status && (
                            <Text mt={"10px"} color="red.200" textAlign="center">{errorMsg.msg}</Text>
                        )
                    }

                    {
                        SuccessMsg.status && (
                            <Text mt={"10px"} color="green" textAlign="center">{SuccessMsg.msg}</Text>
                        )
                    }

                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>

    )
}
